import { render, staticRenderFns } from "./OptionAuflage.vue?vue&type=template&id=55d1bd08&"
import script from "./OptionAuflage.vue?vue&type=script&lang=js&"
export * from "./OptionAuflage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports